export default class BookmakerUrlModel {
  public url: string = null;
  public appType: string = null;
}
